import { render, staticRenderFns } from "./Govhome.vue?vue&type=template&id=45773932&scoped=true"
import script from "./Govhome.vue?vue&type=script&lang=js"
export * from "./Govhome.vue?vue&type=script&lang=js"
import style0 from "./Govhome.vue?vue&type=style&index=0&id=45773932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45773932",
  null
  
)

export default component.exports